import type { NavigationLink } from "../types";
import BrandDropdown from "./BrandDropdown";
import CategoryDropdown from "./CategoryDropdown";
import SimpleDropdown from "./SimpleDropdown";

export default function Dropdown({
  activeLink,
  locale,
}: {
  activeLink: NavigationLink;
  locale?: string;
}) {
  if (!activeLink) return null;

  if (activeLink.type === "Simple") {
    return <SimpleDropdown link={activeLink} locale={locale} />;
  }

  return (
    <div className="border-gray-150 absolute top-0 left-0 w-full border-y bg-white lg:top-full">
      <div className="container grid grid-cols-12">
        {activeLink.type === "Brand" && (
          <BrandDropdown link={activeLink} locale={locale} />
        )}
        {activeLink.type === "Category" && (
          <CategoryDropdown link={activeLink} locale={locale} />
        )}
      </div>
    </div>
  );
}
